import script from "./KpiCardAnalitico.vue?vue&type=script&setup=true&lang=js"
export * from "./KpiCardAnalitico.vue?vue&type=script&setup=true&lang=js"

import "./KpiCardAnalitico.vue?vue&type=style&index=0&id=08766958&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08766958"]])

export default __exports__